const offerDestination = {
  props: {
    dynamicClass: ".c-offers-destination.dynamicLoading",
    compSelector: ".JS-offers-destination",
    offersTabSelector: ".JS-offers-list-tab",
    offersContainerSelector: ".JS-offers-list-container",
    ctaDestinationSelector: ".JS-destination-cta",
    cardSelector: "c-offers-destination-list__card",
    classNameArticle: "c-card-hotel",
    classNameCard: "dataCard",
    hidden: "hidden",
    active: "cmp-tabs__tab--active",
    data: [],
  },
  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-offerDestination.css", this.props.dynamicClass);

    const components = document.querySelectorAll(this.props.compSelector);
    if (components) {
      components.forEach((component) => this.initComponent(component));
    }
  },
  initComponent: function (component) {
    if (!component) {
      return;
    }
    this.initCta(component);
    this.initListeners(component);

    const $elements = component.getElementsByClassName(this.props.cardSelector);
    if (!$elements) {
      return;
    }
    bcl.u.forEach($elements, this.initItem.bind(this));
  },
  initItem: function ($card) {
    const $article = $card.getElementsByClassName(this.props.classNameArticle)[0],
      $containerData = $article.getElementsByClassName(this.props.classNameCard)[0];
    if (!$containerData) {
      return;
    }

    let data = $containerData.getAttribute("data-card");

    data = JSON.parse(data);
    this.props.data.push(data);

    $containerData.setAttribute("data-card", "");
    $article.setAttribute("data-index", this.props.data.length - 1);

    bcl.u.setButtonOfferCard($article, data);
    if (bcl.c.distributor?.results?.detailOffer) {
      bcl.c.distributor.results.detailOffer($card, $article, data);
    }
  },
  initCta: function (component) {
    const linksContainers = component.querySelectorAll(this.props.ctaDestinationSelector);
    if (!linksContainers) {
      return;
    }
    linksContainers.forEach((linkContainer) => {
      const selector = linkContainer.dataset.destinationKey;
      const link = linkContainer.querySelector("a.c-cta");
      if (!selector || !link || !link.href) {
        return;
      }
      let url;
      if (link.href.includes(".html")) {
        url = link.href.split(".html")[0];
        link.href = url + "--" + selector + ".html";
        return;
      }
      url = link.href.slice(0, -1);
      link.href = url + "--" + selector;
    });
  },
  initListeners: function (component) {
    const tabs = component.querySelectorAll(this.props.offersTabSelector);
    if (tabs) {
      tabs.forEach((tab) => {
        this.initTabListener(tab, component, tabs);
      });
    }
  },
  initTabListener: function (tab, component, tabs) {
    const selector = tab.dataset.destinationKey;
    if (!selector) {
      return;
    }
    tab.addEventListener("click", () => {
      this.changeTab(selector, component, tabs);
    });
  },
  changeTab: function (selector, component, tabs) {
    const containers = component.querySelectorAll(this.props.offersContainerSelector);
    if (!containers) {
      return;
    }
    tabs.forEach((tab) => this.toggleActive(selector, tab));
    containers.forEach((container) => this.toggleHidden(selector, container));
    const linksContainers = component.querySelectorAll(this.props.ctaDestinationSelector);
    if (!linksContainers) {
      return;
    }
    linksContainers.forEach((linkContainer) => this.toggleHidden(selector, linkContainer));
  },
  toggleHidden: function (selector, element) {
    element.classList.toggle(this.props.hidden, element.dataset.destinationKey != selector);
  },
  toggleActive: function (selector, tab) {
    tab.classList.toggle(this.props.active, tab.dataset.destinationKey == selector);
  },
};

export default offerDestination;
